// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ContactCardMessage Component Styles
 *
 * Visually distinct from regular bubbles: lighter surface, soft border,
 * icon column on the left. The component is reused in both LiveChat
 * and ConversationDetail timelines, so layout positioning (left vs.
 * right) is controlled by the parent wrapper class.
 */

.contact-card-message {
    display: flex;
    flex-direction: column;
    gap: 10px;
    max-width: 360px;
    padding: 12px 14px;
    border-radius: 14px;
    border: 1px solid #e0e0e0;
    background: #f5faff;
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
    font-size: 14px;
    line-height: 1.4;
    color: #1f2937;
}

.contact-card-message.outbound {
    background: #effaf3;
    border-color: #cdebd6;
}

.contact-card-message.inbound {
    background: #f5faff;
    border-color: #d4e4f7;
}

/* Header row */
.contact-card-header {
    display: flex;
    align-items: flex-start;
    gap: 12px;
}

.contact-card-avatar {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #25D366;
    color: white;
    font-weight: 700;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-transform: uppercase;
}

.contact-card-message.inbound .contact-card-avatar {
    background: #2563eb;
}

.contact-card-heading {
    flex: 1 1;
    min-width: 0;
}

.contact-card-sender {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: #6b7280;
    margin-bottom: 2px;
}

.contact-card-sender-icon {
    font-size: 13px;
}

.contact-card-name {
    font-weight: 600;
    font-size: 15px;
    color: #111827;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.contact-card-badge {
    display: inline-block;
    margin-top: 4px;
    padding: 2px 8px;
    border-radius: 999px;
    background: rgba(37, 99, 235, 0.08);
    color: #2563eb;
    font-size: 11px;
    font-weight: 500;
}

.contact-card-message.outbound .contact-card-badge {
    background: rgba(37, 211, 102, 0.12);
    color: #1c8c4a;
}

/* Body rows */
.contact-card-body {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.contact-card-row {
    display: flex;
    align-items: center;
    gap: 6px;
    flex-wrap: wrap;
}

.contact-card-row-icon {
    font-size: 14px;
    flex-shrink: 0;
}

.contact-card-row-label {
    font-size: 12px;
    color: #6b7280;
    font-weight: 500;
    min-width: 0;
}

.contact-card-row-value {
    color: #111827;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    flex: 1 1;
    min-width: 0;
}

.contact-card-link {
    color: #2563eb;
    text-decoration: none;
}

.contact-card-link:hover,
.contact-card-link:focus-visible {
    text-decoration: underline;
}

.contact-card-cta {
    margin-left: auto;
    padding: 3px 10px;
    border-radius: 999px;
    background: #25D366;
    color: white;
    font-size: 12px;
    font-weight: 600;
    text-decoration: none;
    white-space: nowrap;
}

.contact-card-cta:hover,
.contact-card-cta:focus-visible {
    filter: brightness(0.95);
    text-decoration: none;
}

.contact-card-empty {
    font-size: 12px;
    color: #9ca3af;
    font-style: italic;
}

/* Footer */
.contact-card-footer {
    display: flex;
    justify-content: flex-end;
    font-size: 11px;
    color: #9ca3af;
}

.contact-card-timestamp {
    white-space: nowrap;
}
`, "",{"version":3,"sources":["webpack://./src/components/ContactCardMessage.css"],"names":[],"mappings":"AAAA;;;;;;EAME;;AAEF;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA,eAAe;AACf;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;AAC3B;;AAEA;IACI,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,oBAAoB;IACpB,mCAAmC;IACnC,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;IACpC,cAAc;AAClB;;AAEA,cAAc;AACd;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;IACnB,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,qBAAqB;AACzB;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;IACjB,oBAAoB;IACpB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,qBAAqB;IACrB,mBAAmB;AACvB;;AAEA;;IAEI,wBAAwB;IACxB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;;AAEA,WAAW;AACX;IACI,aAAa;IACb,yBAAyB;IACzB,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":["/* ContactCardMessage Component Styles\n *\n * Visually distinct from regular bubbles: lighter surface, soft border,\n * icon column on the left. The component is reused in both LiveChat\n * and ConversationDetail timelines, so layout positioning (left vs.\n * right) is controlled by the parent wrapper class.\n */\n\n.contact-card-message {\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    max-width: 360px;\n    padding: 12px 14px;\n    border-radius: 14px;\n    border: 1px solid #e0e0e0;\n    background: #f5faff;\n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);\n    font-size: 14px;\n    line-height: 1.4;\n    color: #1f2937;\n}\n\n.contact-card-message.outbound {\n    background: #effaf3;\n    border-color: #cdebd6;\n}\n\n.contact-card-message.inbound {\n    background: #f5faff;\n    border-color: #d4e4f7;\n}\n\n/* Header row */\n.contact-card-header {\n    display: flex;\n    align-items: flex-start;\n    gap: 12px;\n}\n\n.contact-card-avatar {\n    flex-shrink: 0;\n    width: 40px;\n    height: 40px;\n    border-radius: 50%;\n    background: #25D366;\n    color: white;\n    font-weight: 700;\n    font-size: 14px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-transform: uppercase;\n}\n\n.contact-card-message.inbound .contact-card-avatar {\n    background: #2563eb;\n}\n\n.contact-card-heading {\n    flex: 1;\n    min-width: 0;\n}\n\n.contact-card-sender {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    font-size: 12px;\n    color: #6b7280;\n    margin-bottom: 2px;\n}\n\n.contact-card-sender-icon {\n    font-size: 13px;\n}\n\n.contact-card-name {\n    font-weight: 600;\n    font-size: 15px;\n    color: #111827;\n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n}\n\n.contact-card-badge {\n    display: inline-block;\n    margin-top: 4px;\n    padding: 2px 8px;\n    border-radius: 999px;\n    background: rgba(37, 99, 235, 0.08);\n    color: #2563eb;\n    font-size: 11px;\n    font-weight: 500;\n}\n\n.contact-card-message.outbound .contact-card-badge {\n    background: rgba(37, 211, 102, 0.12);\n    color: #1c8c4a;\n}\n\n/* Body rows */\n.contact-card-body {\n    display: flex;\n    flex-direction: column;\n    gap: 6px;\n}\n\n.contact-card-row {\n    display: flex;\n    align-items: center;\n    gap: 6px;\n    flex-wrap: wrap;\n}\n\n.contact-card-row-icon {\n    font-size: 14px;\n    flex-shrink: 0;\n}\n\n.contact-card-row-label {\n    font-size: 12px;\n    color: #6b7280;\n    font-weight: 500;\n    min-width: 0;\n}\n\n.contact-card-row-value {\n    color: #111827;\n    max-width: 100%;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    flex: 1;\n    min-width: 0;\n}\n\n.contact-card-link {\n    color: #2563eb;\n    text-decoration: none;\n}\n\n.contact-card-link:hover,\n.contact-card-link:focus-visible {\n    text-decoration: underline;\n}\n\n.contact-card-cta {\n    margin-left: auto;\n    padding: 3px 10px;\n    border-radius: 999px;\n    background: #25D366;\n    color: white;\n    font-size: 12px;\n    font-weight: 600;\n    text-decoration: none;\n    white-space: nowrap;\n}\n\n.contact-card-cta:hover,\n.contact-card-cta:focus-visible {\n    filter: brightness(0.95);\n    text-decoration: none;\n}\n\n.contact-card-empty {\n    font-size: 12px;\n    color: #9ca3af;\n    font-style: italic;\n}\n\n/* Footer */\n.contact-card-footer {\n    display: flex;\n    justify-content: flex-end;\n    font-size: 11px;\n    color: #9ca3af;\n}\n\n.contact-card-timestamp {\n    white-space: nowrap;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
